import React, { useContext } from "react";
import { GlobalContext } from "../../context/global.context";
import "./controls.scss";

const Controls = ({ className = "", btnClassName = "" }) => {
  const {
    isPlaying,
    isLoading,
    isPaused,
    isMute,
    volumeIndex,
    handlePlay,
    handleStop,
    handleMute,
    handleVolume,
  } = useContext(GlobalContext);

  const isSpinning = isLoading;

  return (
    <div className={`controls ${className}`}>
      <button
        className={`controls__btn ${btnClassName} ${isPlaying ? "controls__btn--disabled" : ""} ${isSpinning ? "controls__btn--spinning" : ""}`}
        onClick={handlePlay}
        aria-label="Play"
        disabled={isPlaying}
      >
        <img src="/img/button_play.png" alt="play" />
      </button>
      <button
        className={`controls__btn ${btnClassName} ${(!isPlaying && !isLoading && !isPaused) ? "controls__btn--disabled" : ""}`}
        onClick={handleStop}
        aria-label="Stop"
        disabled={!isPlaying && !isLoading && !isPaused}
      >
        <img src="/img/button_stop.png" alt="stop" />
      </button>
      <button
        className={`controls__btn ${btnClassName}`}
        onClick={handleMute}
        aria-label="Sound"
      >
        <img src={`img/button_${isMute ? "no_" : ""}sound.png`} alt="sound" />
      </button>
      <button
        className={`controls__btn ${btnClassName}`}
        onClick={handleVolume}
        aria-label="Volume"
      >
        <img src={`img/vol_${volumeIndex}.png`} alt={`volume ${volumeIndex}`} />
      </button>
    </div>
  );
};

export default Controls;
